import './accordionComponent.scss';
import React, {JSXElementConstructor, ReactElement, useCallback, useEffect} from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChipComponent from "../chip/ChipComponent";
import {CommonService} from "../../services";

interface AccordionComponentProps {
    title?: string;
    subTitle?: string;
    statusLabel?: string;
    statusIcon?: ReactElement<any, string | JSXElementConstructor<any>> | undefined;
    actions?: React.ReactNode;
    isExpanded?: boolean;
    onChange?: (isExpanded: boolean) => void;
    disabled?: any;
    disableExpanding?: boolean;
    name?: string;
    forActivityLog?: boolean;
}

const AccordionComponent = (props: React.PropsWithChildren<AccordionComponentProps>) => {

        const {title, subTitle, statusLabel, statusIcon, actions, children, onChange, disabled, name} = props;
        let {disableExpanding, forActivityLog} = props;
        if (!disableExpanding) {
            disableExpanding = false;
        }
        if (!forActivityLog) forActivityLog = false;
        const [isExpanded, setIsExpanded] = React.useState<any>(props.isExpanded);

        const handleChange = useCallback((isExpanded: any) => {
            setIsExpanded(isExpanded);
            if (onChange) {
                onChange(isExpanded);
            }
        }, [onChange]);

        useEffect(() => {
            setIsExpanded(props.isExpanded);
        }, [props.isExpanded]);

        return (
            <div className="accordion-wrapper">
                <Accordion
                    disabled={disabled}
                    expanded={isExpanded}
                    onChange={(e, isExpanded) => {
                        if (disableExpanding) {
                            e.stopPropagation()
                        } else {
                            handleChange(isExpanded)
                        }
                    }
                    }>
                    <AccordionSummary
                        expandIcon={!disableExpanding && <ExpandMoreIcon/>}
                        className="accordion-summary"
                    >
                        <div className={"accordion-header"} onClick={(e: any) => disableExpanding && e.stopPropagation()}>
                            <div className={"accordian-title-status-wrapper"}>
                                <div className="accordian-tile">
                                    {title && (!forActivityLog ? CommonService.capitalize(title) : CommonService.capitalizeFirstLetterOfEachWord(title))}
                                </div>
                                <div className="accordian-sub-tile">
                                    {subTitle}
                                </div>
                                {
                                    name && <div className="accordian-user-name">
                                        {CommonService.capitalizeFirstLetterOfEachWord(name)}
                                    </div>
                                }
                                {statusLabel && <div className="accordian-status">
                                    <ChipComponent
                                        label={statusLabel}
                                        icon={statusIcon}/>
                                </div>}
                            </div>
                            {
                                actions &&
                                <div className="accordian-actions"
                                     onClick={(e) => e.stopPropagation()}>
                                    {actions}
                                </div>
                            }
                        </div>
                    </AccordionSummary>
                    <AccordionDetails>
                        {children}
                    </AccordionDetails>
                </Accordion>
            </div>
        )

    }

;

export default AccordionComponent;